module.exports = __webpack_public_path__ + "static/media/telescopeDoor.d5a02871.png";